// src/component/FirestoreReadCheck.js
import React, { useState } from "react";
import { Box, Typography, Button, Stack } from "@mui/material";
import { collection, getDocs, query, limit } from "firebase/firestore";
import { db } from "../api/firebase"; // ★ここで固定import

export default function FirestoreReadCheck() {
  const [results, setResults] = useState({});

  const checkCollection = async (colName) => {
    try {
      const q = query(collection(db, colName), limit(1));
      const snap = await getDocs(q);

      setResults((prev) => ({
        ...prev,
        [colName]: { status: "OK", message: `read OK（docs=${snap.size}）` },
      }));
    } catch (e) {
      setResults((prev) => ({
        ...prev,
        [colName]: {
          status: "ERROR",
          message: `${e.code || "error"} : ${e.message}`,
        },
      }));
    }
  };

  const targets = ["musicDailyUserPlays", "musicListeningSessions"];

  return (
    <Box sx={{ p: 2, border: "1px solid #ccc", borderRadius: 2 }}>
      <Typography variant="h6" sx={{ mb: 1 }}>
        Firestore Read Check（止血確認）
      </Typography>

      <Stack spacing={1}>
        {targets.map((col) => (
          <Box key={col}>
            <Button variant="outlined" size="small" onClick={() => checkCollection(col)}>
              {col.toUpperCase()} を READ してみる
            </Button>

            {results[col] && (
              <Typography
                variant="caption"
                sx={{
                  display: "block",
                  mt: 0.5,
                  color: results[col].status === "OK" ? "green" : "error.main",
                }}
              >
                {results[col].message}
              </Typography>
            )}
          </Box>
        ))}
      </Stack>
    </Box>
  );
}
